export default {
  // Header
  "co.header.badge": "Consultoria Estrategica",
  "co.header.back": "Regresar",
  "co.header.active": "Consultoria Activa",

  // Hero slides
  "co.hero.slide1.tag": "Consultoria Estrategica",
  "co.hero.slide1.title": "Transformacion Digital",
  "co.hero.slide1.highlight": "con Seguridad",
  "co.hero.slide1.subtitle": "Asesoria especializada para fortalecer la postura de seguridad de tu organizacion con metodologias probadas y frameworks internacionales como ISO 27001, NIST y PCI DSS.",
  "co.hero.slide1.cta": "Ver servicios",

  "co.hero.slide2.tag": "Assessment y Diagnostico",
  "co.hero.slide2.title": "Evaluacion Integral",
  "co.hero.slide2.highlight": "de Seguridad",
  "co.hero.slide2.subtitle": "Realizamos diagnosticos exhaustivos de tu infraestructura, procesos y controles de seguridad para identificar vulnerabilidades y definir hojas de ruta priorizadas.",
  "co.hero.slide2.cta": "Conocer mas",

  "co.hero.slide3.tag": "Cumplimiento Normativo",
  "co.hero.slide3.title": "Gobierno y",
  "co.hero.slide3.highlight": "Compliance",
  "co.hero.slide3.subtitle": "Acompanamiento completo para alcanzar y mantener certificaciones internacionales, adecuacion a leyes de proteccion de datos y cumplimiento regulatorio sectorial.",
  "co.hero.slide3.cta": "Ver certificaciones",

  "co.hero.backHome": "Volver al Inicio",

  // Features
  "co.features.tag": "Servicios",
  "co.features.title": "Capacidades de",
  "co.features.highlight": "Consultoria",
  "co.features.subtitle": "Servicios profesionales de consultoria con metodologias internacionales y un equipo de especialistas certificados",

  "co.features.f1.title": "Consultoria de Seguridad",
  "co.features.f1.desc": "Asesoria especializada para fortalecer la postura de seguridad con metodologias probadas y mejores practicas de la industria. Evaluacion integral de tu entorno actual.",
  "co.features.f1.stat": "ISO 27001",
  "co.features.f1.statLabel": "Certificacion",

  "co.features.f2.title": "Assessment Tecnologico",
  "co.features.f2.desc": "Diagnostico exhaustivo de infraestructura, redes y seguridad. Identificacion de vulnerabilidades, brechas de cumplimiento y recomendaciones priorizadas con hojas de ruta.",
  "co.features.f2.stat": "200+",
  "co.features.f2.statLabel": "Assessments",

  "co.features.f3.title": "Cumplimiento Normativo",
  "co.features.f3.desc": "Adecuacion a marcos regulatorios como ISO 27001, PCI DSS, NIST y leyes de proteccion de datos personales. Acompanamiento en auditorias y certificaciones.",
  "co.features.f3.stat": "15+",
  "co.features.f3.statLabel": "Frameworks",

  "co.features.f4.title": "Gestion de Riesgos",
  "co.features.f4.desc": "Identificacion, analisis y tratamiento de riesgos de seguridad de la informacion con metodologias cuantitativas y cualitativas alineadas a ISO 31000 e ISO 27005.",
  "co.features.f4.stat": "500+",
  "co.features.f4.statLabel": "Riesgos mitigados",

  "co.features.f5.title": "Continuidad de Negocio",
  "co.features.f5.desc": "Desarrollo de BCP y DRP con analisis de impacto (BIA), estrategias de recuperacion y pruebas periodicas para garantizar la continuidad operativa ante cualquier escenario.",
  "co.features.f5.stat": "RTO < 4h",
  "co.features.f5.statLabel": "Garantizado",

  "co.features.f6.title": "Implementacion SGSI",
  "co.features.f6.desc": "Diseno e implantacion de Sistemas de Gestion de Seguridad de la Informacion con politicas, procedimientos y controles alineados a los objetivos estrategicos de tu organizacion.",
  "co.features.f6.stat": "50+",
  "co.features.f6.statLabel": "SGSI implementados",

  // CTA
  "co.cta.tag": "Iniciar Consultoria",
  "co.cta.title": "Impulsa tu seguridad con",
  "co.cta.subtitle": "Un equipo de consultores certificados con experiencia en multiples industrias listo para transformar la seguridad de tu organizacion",
  "co.cta.button": "Solicitar asesoria gratuita",
  "co.cta.homeButton": "Ver sitio principal",
};